<template>
    <layout
        :showuserinfo="false"
        :title="'Cukai Tanah: ' + this.noHm"
        :crumbs="crumbs"
    >
        <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>

        <z-page title="Butiran Hak Milik" :append-button="true">
            <hakmilik :cukai="culai" />
        </z-page>

        <w-dialog
            v-if="dialog.show"
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <w-form @success="submit()" v-model="valid">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukkan No. MMK"
                            v-model="form.no_tauliah"
                            >No. MMK</w-input
                        >
                    </div>

                    <div class="xs6">
                        <w-select
                            label="Pemilik"
                            placeholder="Sila Pilih Pemilik"
                            v-model="form.profil_id"
                            :items="pemiliks"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3 mb5">
                    <div class="xs6 mr3">
                        <w-input type="date" v-model="form.tarikh_mula"
                            >Tarikh Mula</w-input
                        >
                    </div>
                    <div class="xs6">
                        <w-input
                            type="date"
                            v-model="form.tarikh_tamat"
                            :validators="[validators.required]"
                            >Tarikh Tamat</w-input
                        >
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-select
                            label="Kategori"
                            placeholder="Sila Pilih Kategori"
                            v-model="form.lkp_hm_ampun_hasil_id"
                            :items="kodKategori"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="0.00"
                            v-model="form.amaun"
                            type="number"
                            :validators="[validators.required]"
                            >Amaun Ampun (RM)</w-input
                        >
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input type="file" placeholder="Muat Naik Watikah">
                            Watikah
                        </w-input>
                    </div>
                </w-flex>
                <div class="d-flex justify-end mt3">
                    <w-button
                        @click="dialog.show = false"
                        class="my1 mr3"
                        :disabled="valid === false"
                        :loading="registering"
                        text
                    >
                        Batal
                    </w-button>
                    <w-button
                        class="my1 mr0"
                        type="submit"
                        :disabled="valid === false"
                        :loading="registering"
                    >
                        Daftar
                    </w-button>
                </div>
            </w-form>
        </w-dialog>

        <z-page
            class="mt3"
            title="Pecahan Amaun Ampun Hasil"
            :append-button="true"
        >
            <!-- <w-flex v-if="$zutil.can('Cukai Kemaskini')"> -->
            <w-flex>
                <div class="spacer"></div>
                <w-button :loading="registering" class="align-self-end" v-if="is_kemaskini_pecahan" @click="is_kemaskini_pecahan= false" text>
                    Batal&nbsp;
                </w-button>
                <w-button :loading="registering" class="align-self-end" v-if="is_kemaskini_pecahan" @click="simpanPecahan">
                    Simpan&nbsp;
                    <w-icon> fal fa-save </w-icon>
                </w-button>
                <!-- <w-button class="align-self-end" v-if="!is_kemaskini_pecahan" @click="is_kemaskini_pecahan= true">
                    Kemaskini&nbsp;
                    <w-icon> fal fa-pencil </w-icon>
                </w-button> -->
            </w-flex>
            <table class="mb2 table-dashboard" width="100%">
                <thead>
                    <tr>
                        <td>Kod Hasil</td>
                        <td>Keterangan</td>
                        <td>Amaun (RM)</td>
                        <td>Amaun Ampun Hasil (RM)</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="cukais13">
                        <td>
                            {{ cukais13.kod_hasil }}
                        </td>
                        <td>
                            {{ cukais13.keterangan }}
                        </td>
                        <td>
                            {{ cukais13.amaun_debit }}
                        </td>
                        <td>
                            <span v-if="!is_kemaskini_pecahan">
                                {{ cukais13.amaun_ampun_hasil ?? '0.00'}}
                            </span>
                            <w-input
                                v-if="is_kemaskini_pecahan"
                                v-model="form.amaun13"
                                type="number"
                                :validators="[validators.required]"
                            />

                        </td>
                    </tr>
                    <tr v-if="Object.keys(cukais28).length > 0">
                        <td>
                            {{ cukais28.kod_hasil }}
                        </td>
                        <td>
                            {{ cukais28.keterangan }}
                        </td>
                        <td>
                            {{ cukais28.amaun_debit }}
                        </td>
                        <td>
                            <span v-if="!is_kemaskini_pecahan">
                                {{ cukais28.amaun_ampun_hasil ?? '0.00' }}
                            </span>
                            <w-input
                                v-if="is_kemaskini_pecahan"
                                v-model="form.amaun28"
                                type="number"
                                :validators="[validators.required]"
                            />
                        </td>
                    </tr>
                    <tr style="background-color: #23478110">
                        <td colspan="3" style="text-align: right">
                            JUMLAH AMAUN AMPUN HASIL
                        </td>
                        <td class="text-left">
                            <span v-if="!is_kemaskini_pecahan">
                                {{ ((parseFloat(cukais28.amaun_ampun_hasil ?? 0)) + parseFloat(cukais13.amaun_ampun_hasil ?? 0)).toFixed(2) }}
                            </span>

                            <span v-if="is_kemaskini_pecahan">
                                {{ form.amaun13 + form.amaun28 }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </z-page>
        <z-page class="mt3" title="Senarai Ampun Hasil" :append-button="true">
            <!-- <w-flex v-if="$zutil.can('Cukai Kemaskini')"> -->
            <w-flex>
                <div class="spacer"></div>
                <w-button class="align-self-end" @click="dialog.show = true">
                    Tambah&nbsp;
                    <w-icon> fal fa-plus </w-icon>
                </w-button>
            </w-flex>
            <w-alert info icon-outside>
                Sila kemaskini <i>"Pecahan Amaun Ampun Hasil"</i> bagi setiap cukai setelah ampun
                hasil didaftarkan.
            </w-alert>
            <Table
                :headers="ampunHasil.headers.filter(header => !header.hidden)"
                :items="ampunHasil.items"
                :loading="loading"
            >
                <template
                    #item-cell.tarikh_mula="{ item, label, header, index }"
                >
                    <div v-if="item.tarikh_mula != null">
                        {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Mula
                    </div>
                </template>

                <template
                    #item-cell.tarikh_tamat="{ item, label, header, index }"
                >
                    {{ moment(item.tarikh_tamat).format("DD-MM-YYYY") }}
                </template>
                <template #item-cell.file="{ item, label, header, index }">
                    <w-button v-if="item.file" @click="dokumen(item.file)">
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on"> fal fa-file </w-icon>
                            </template>
                            Papar
                        </w-tooltip>
                    </w-button>
                    <h1 v-else>Tiada</h1>
                </template>
                <!-- <template #item-cell.action="{ item, label, header, index }" v-if="$zutil.can('Cukai Kemaskini')"> -->
                <template #item-cell.action="{ item, label, header, index }">
                    <inertia-link
                        :href="$route('cukai-tanah.kemasAmpun')"
                        :data="{ no_hm: item.no_hm }"
                    >
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on"> fal fa-pencil </w-icon>
                            </template>
                            Kemaskini
                        </w-tooltip>
                    </inertia-link>
                </template>
            </Table>
        </z-page>
        <!---->
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import moment from "moment";
import Table from "../Component/Table";

export default {
    extends: ZResource,
    props: {
        noHm: [Object],
    },
    components: {
        Hakmilik,
        Table,
    },
    data() {
        return {
            valid: null,
            validators: {
                required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            loading: true,
            registering: false,

            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,

            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            kodKategori: [{ label: "Loading", selected: true }],
            pemiliks: [{ label: "Loading", selected: true }],
            form: {
                hm_akaun_id: null,
                lkp_hm_ampun_hasil_id: null,
                keluasan: null,
                no_tauliah: null,
                tarikh_mula: null,
                tarikh_tamat: null,
                amaun13: 0,
                amaun28: 0,
                status: 1,
                profil_id: null,
            },
            culai: {},
            ampunHasil: {
                headers: [
                    { label: "No. Hak Milik", key: "no_hm" },
                    { label: "No. MMK", key: "no_tauliah" },
                    { label: "Pemilik", key: "pemilik" },
                    { label: "Keluasan Hak Milik", key: "keluasan" },
                    { label: "Keluasan Maksimum", key: "keluasan_mak" },
                    { label: "Kategori", key: "kategori" },
                    // { label: "Amaun Cukai (RM)", key: "amaun_cukai" },
                    { label: "Amaun Ampun (RM)", key: "amaun" },
                    // { label: "Peratus Ampun", key: "peratus_ampun" },
                    { label: "Tempoh Mula", key: "tarikh_mula" },
                    { label: "Tempoh Tamat", key: "tarikh_tamat" },
                    { label: "Status", key: "status" },
                    { label: "Dokumen", key: "file", align: "center" },
                    { label: "Tindakan", key: "action", align: "center", hidden: true },
                ],
                items: [],
            },
            cukais13: {
                amaun_ampun_hasil: 0
            },
            cukais28: {
                amaun_ampun_hasil: 0
            },
            dialog: {
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
            },
            is_kemaskini_pecahan: false
        };
    },
    methods: {
        async kategori() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenis-ampun-hasil`,
                responseType: "json",
            }).then((e) => {
                this.kodKategori = e.data.map((d) => {
                    return { label: d.id + " - " + d.keterangan, value: d.id };
                });
            });
        },

        async submit() {
            this.registering = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil`,
                responseType: "json",
                data: this.form,
            })
                .catch((err) => {
                    this.$waveui.notify({
                        error: true,
                        message: "Ralat",
                        timeout: 3000,
                    });
                })
                .finally((e) => {
                    this.fetchData2();
                    this.registering = false;
                    this.dialog.show = false;
                    this.$waveui.notify({
                        success: true,
                        message: "BERJAYA",
                        timeout: 3000,
                    });
                });
        },

        async simpanPecahan() {
            this.registering = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil/pecahan-ampun-hasil`,
                responseType: "json",
                data: {
                    hm_akaun_id: this.form.hm_akaun_id,
                    amaun13: this.form.amaun13,
                    amaun28: this.form.amaun28,
                },
            })
                .catch((err) => {
                    this.$waveui.notify({
                        error: true,
                        message: "Ralat",
                        timeout: 3000,
                    });
                })
                .finally((e) => {
                    this.registering = false;
                    if(Object.keys(this.cukais13).length > 0){
                        this.cukais13.amaun_ampun_hasil = this.form.amaun13.toFixed(2)
                    }
                    if(Object.keys(this.cukais28).length > 0){
                        this.cukais28.amaun_ampun_hasil = this.form.amaun28.toFixed(2)
                    }
                    this.is_kemaskini_pecahan = false
                    this.$waveui.notify({
                        success: true,
                        message: "BERJAYA",
                        timeout: 3000,
                    });
                });
        },
        async getAmpunHasil() {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                kod_daerah: this.noHm.substring(2, 4),
                barcode: this.noHm,
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            }).then((e) => {
                if (e.data.length > 0) {
                    this.form.keluasan = e.data[0].keluasan;
                    this.form.hm_akaun_id = e.data[0].id;
                    this.culai = e.data[0];
                    this.pemiliks = e.data[0].pemiliks.map((d) => {
                        return { label: d.id + " - " + d.nama, value: d.id };
                    });
                    const cukais = e.data[0].cukais;
                    this.cukais13 = cukais.find((e) => e.akaun_id == 13) ?? {};
                    this.cukais28 = cukais.find((e) => e.akaun_id == 28) ?? {};
                    this.form.amaun13 = parseFloat(this.cukais13?.amaun_ampun_hasil ?? 0);
                    this.form.amaun28 = parseFloat(this.cukais28?.amaun_ampun_hasil ?? 0);
                }
            });
        },
        async fetchData2() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil?no_hm=${this.noHm}`,
                params: {
                    limit: 100,
                    offset: 0,
                },
                responseType: "json",
            })
                .then((e) => {
                    const { data, limit, offset, total } = e.data;
                    this.ampunHasil.items = data;
                })
                .finally((_) => {
                    this.loading = false;
                });
        },
        kembali() {
            window.history.back();
        },
    },
    watch: {},
    computed: {
        moment: () => moment,
    },
    mounted() {
        // override default setting
        this.kategori(), this.getAmpunHasil();
        this.fetchData2();
        this.dialog.width = 500;
    },
};
</script>
<style>
    div.w-menu.w-select__menu.w-menu--bottom.w-menu--align-left{
        z-index: 500;
    }
</style>
